<template>
    <router-link :to="{name: 'home'}">
        <div v-if="isPartner" class="flex flex-col items-center">
            <img
                :alt="`${(advisory_partner_profile.name || 'Valur')} logo`"
                :class="logoClass"
                :height="(advisory_partner_profile.style || {})['header_logo_style'] === undefined ? 15: ''"
                :src="logoVariant"
                :style="(advisory_partner_profile.style || {})['header_logo_style']"
            >
            <span
                v-if="isPartner && advisory_partner_profile.is_powered_by"
                class="text-xs text-gray-400"
            >
                Powered by Valur
            </span>
        </div>
        <img
            v-else
            alt="Valur logo"
            :class="logoClass"
            :src="valurLogoVariant"
        >
    </router-link>
</template>

<script>
    import advisory_partner_mixin from '@/mixins/advisory_partner_mixin';

    export default {
        name: 'v-logo',
        mixins: [
            advisory_partner_mixin,
        ],
        props: {
            icon: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            hasLogoIcon() {
                return this.advisory_partner_profile.logo_icon_url !== null;
            },
            logoClass () {
                return (this.icon && this.hasLogoIcon) ? 'w-24' : this.icon ? 'w-28 py-6' : 'w-28';
            },
            logoVariant() {
                const logoIconUrl = this.advisory_partner_profile.logo_icon_url;
                const logoUrl = this.advisory_partner_profile.logo_url;
                return (this.icon && this.hasLogoIcon) ? logoIconUrl : logoUrl;
            },
            valurLogoVariant() {
                return this.icon ? require('@/assets/img/logo_icon.png') : require('@/assets/img/logo.png');
            },
        },
    };
</script>
